import { withStyles, withTheme } from '@material-ui/core/styles';
import Attractions, { styles as attractionStyles } from './Attractions';
import Info, { styles as infoStyles } from './Info';

export const BusinessAttractions = withStyles(attractionStyles)(Attractions);
export const BusinessInfo = withStyles(infoStyles)(withTheme(Info));
export const PlanListSlick = withTheme(
  withStyles(require('../Shared/ListSlick').styles)(
    require('./PlanListSlick').default,
  ),
);

export { default as BusinessQuestion } from './Question';

export const ATTRACTION_LIMIT = 3;
